import { type IEventBroker } from '@zdrbm/zdr-native-tools';
import { IImage } from '../imageService';

export enum ScreenshotStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
}

export enum ScreenshotType {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
}

export interface CaptureScreenResult {
  image?: IImage;
  status: ScreenshotStatus;
  error?: string;
}
export interface CaptureScreenOptions {
  type?: ScreenshotType;
  quality?: number;
}

export interface IScreenshotService {
  takingScreenshot: IEventBroker;
  screenshotTaken: IEventBroker;
  captureScreen(): Promise<CaptureScreenResult>;
}